import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Hero from './components/Hero';

ReactDOM.render(<App />,document.getElementById('root'));
